module.exports = __webpack_public_path__ + "img/jornay-mobile-logo.b7484560.svg";